import { apiRequest } from '@/utils/api-request';

export async function deleteLabel(
  orgId: string,
  labelId: string,
): Promise<void> {
  await apiRequest({
    url: `/api/v1/orgs/${orgId}/labels/${labelId}`,
    target: 'workflow',
    method: 'DELETE',
  });
}
